import React, { useEffect } from "react";
import "./aboutbanner.css";
import Aos from "aos";
import "aos/dist/aos.css";
import Banner from "../Banner/Banner";
import { Helmet } from "react-helmet";

const AboutBanner = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="aboutbanner">
      <Helmet>
        <title>About Myths Egypt Tours | Travel Experts in Egypt</title>
        <meta
          name="description"
          content="Learn about Myths Egypt Tours – your trusted travel agency for authentic Egypt tours, packages, and unique experiences."
        />
        <meta
          name="keywords"
          content="about Myths Egypt Tours, Egypt travel agency, tourism company in Egypt"
        />
        <meta property="og:title" content="About Myths Egypt Tours | Travel Experts in Egypt" />
        <meta
          property="og:description"
          content="Get to know Myths Egypt Tours, a professional travel agency offering unforgettable tours across Egypt."
        />
        <meta property="og:url" content="https://mythsegypttours.com/about-us" />
        <meta property="og:image" content="https://mythsegypttours.com/og-image.jpg" />
      </Helmet>

      <Banner page="about" />
    </section>
  );
};

export default AboutBanner;
